module.exports = __webpack_public_path__ + "static/media/general-de-seguros-thumbs.ddc0632d.svg";